'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFlightTakeoff = function MdFlightTakeoff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm36.8 16.1c0.3 1.3-0.5 2.7-1.8 3-5.4 1.5-10.7 2.9-16.1 4.3l-8.8 2.4-2.7 0.8c-1.4-2.5-2.9-5-4.4-7.5l2.5-0.7 3.3 2.5 8.2-2.2-6.8-11.9 3.2-0.9 11.4 10.7 9-2.3c1.3-0.4 2.7 0.5 3 1.8z m-32.7 15.5h31.8v3.4h-31.8v-3.4z' })
        )
    );
};

exports.default = MdFlightTakeoff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/flight-takeoff.js
// module id = 1532
// module chunks = 168707334958949